import { render, staticRenderFns } from "./fee-sheet-row-notes.vue?vue&type=template&id=4742c6a4&scoped=true&"
import script from "./fee-sheet-row-notes.vue?vue&type=script&lang=ts&"
export * from "./fee-sheet-row-notes.vue?vue&type=script&lang=ts&"
import style0 from "./fee-sheet-row-notes.vue?vue&type=style&index=0&id=4742c6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742c6a4",
  null
  
)

export default component.exports